import type { ReactElement } from 'react'

interface DotProps {
  isInCollectionSet: boolean
  isSelected: boolean
  isHovered: boolean
}

export function Dot({ isInCollectionSet, isSelected, isHovered }: DotProps): ReactElement {
  const colourClass = isInCollectionSet
    ? 'border-emerald-500 bg-emerald-100 dark:bg-emerald-900'
    : 'border-slate-400 dark:border-slate-500 bg-white dark:bg-slate-700'
  const selectedClass = isSelected ? 'ring-2 ring-fuchsia-500 ring-offset-1 scale-125' : ''
  const hoverClass = isHovered ? 'scale-150' : ''
  return (
    <div
      className={`h-3 w-3 rounded-full border-2 transition-all ${colourClass} ${selectedClass} ${hoverClass}`}
    />
  )
}

interface DotTooltipProps {
  hostname: string
  ipAddress: string
}

export function DotTooltip({ hostname, ipAddress }: DotTooltipProps): ReactElement {
  return (
    <div
      className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 -translate-x-1/2"
      style={{ minWidth: '120px' }}
    >
      <div className="rounded-lg bg-slate-900 px-2 py-1.5 text-xs text-white shadow-lg dark:bg-slate-700">
        <div className="truncate font-semibold">{hostname}</div>
        <div className="font-mono text-[10px] text-slate-300">{ipAddress}</div>
      </div>
      <div className="absolute top-full left-1/2 h-0 w-0 -translate-x-1/2 border-t-4 border-r-4 border-l-4 border-transparent border-t-slate-900 dark:border-t-slate-700" />
    </div>
  )
}
